module.exports = __webpack_public_path__ + "svg/flags/Korea, Democratic People's Republic of.svg";